"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONWriterOption = exports.TextType = void 0;
var TDJSONOption_1 = require("./TDJSONOption");
var TextType;
(function (TextType) {
    TextType[TextType["OPERATOR"] = 0] = "OPERATOR";
    TextType[TextType["KEY"] = 1] = "KEY";
    TextType[TextType["STRING"] = 2] = "STRING";
    TextType[TextType["NON_STRING"] = 3] = "NON_STRING";
})(TextType = exports.TextType || (exports.TextType = {}));
var TDJSONWriterOption = /** @class */ (function (_super) {
    __extends(TDJSONWriterOption, _super);
    function TDJSONWriterOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mIndentFactor = 0;
        _this.alwaysQuoteName = true;
        _this.quoteChar = '"';
        /** @internal */
        _this.indentStr = ''; // Used internally
        /** Node mapper, if it returns null, node will be skipped */
        _this.nodeFilters = [];
        return _this;
    }
    Object.defineProperty(TDJSONWriterOption.prototype, "indentFactor", {
        get: function () { return this.mIndentFactor; },
        set: function (indentFactor) {
            this.mIndentFactor = indentFactor;
            this.indentStr = ' '.repeat(this.mIndentFactor);
        },
        enumerable: false,
        configurable: true
    });
    TDJSONWriterOption.prototype.setIndentFactor = function (indentFactor) { this.indentFactor = indentFactor; return this; };
    TDJSONWriterOption.prototype.setIndentStr = function (str) { this.indentStr = str; return this; };
    TDJSONWriterOption.prototype.setAlwaysQuoteName = function (alwaysQuoteName) { this.alwaysQuoteName = alwaysQuoteName; return this; };
    TDJSONWriterOption.prototype.setQuoteChar = function (quoteChar) { this.quoteChar = quoteChar; return this; };
    TDJSONWriterOption.prototype.setTextDecorator = function (deco) { this.textDecorator = deco; return this; };
    TDJSONWriterOption.prototype.hasIndent = function () {
        return this.indentStr.length > 0;
    };
    TDJSONWriterOption.prototype.applyFilters = function (n) {
        var result = n;
        for (var _i = 0, _a = this.nodeFilters; _i < _a.length; _i++) {
            var f = _a[_i];
            if (result == null)
                break;
            result = f.apply(result);
        }
        return result;
    };
    TDJSONWriterOption.prototype.addNodeFilter = function () {
        var filters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            filters[_i] = arguments[_i];
        }
        for (var _a = 0, filters_1 = filters; _a < filters_1.length; _a++) {
            var f = filters_1[_a];
            this.nodeFilters.push(f);
        }
        return this;
    };
    TDJSONWriterOption.prototype.deco = function (text, type) {
        return this.textDecorator == null ? text : this.textDecorator(text, type);
    };
    return TDJSONWriterOption;
}(TDJSONOption_1.TDJSONOption));
exports.TDJSONWriterOption = TDJSONWriterOption;
//# sourceMappingURL=TDJSONWriterOption.js.map